export type Defect = {
  defectId: number;
  description: string | null;
  estimateDefectCost: number | null;
  estimateDefectCostRangeId: number | null;
  gradingArea: string;
  images: string | null;
  inspectionId: string;
  key: string | null;
  notes: string | null;
  photoFolder: string | null;
  priority: number;
  rawAnswer: string | null;
  recommendations: string | null;
  shortGenName: string | null;
  status: number;
  typeCode: string | null;
  codeAssignReason?: string | null;
  [key: string]: unknown;
};

export enum DefectPriority {
  "High" = 2,
  "Medium" = 3,
  "Low" = 5,
}

export enum DefectStatus {
  "Open" = 0,
  "Closed" = 1,
  "In Progress" = 2,
  "Rectified" = 3,
  "Expired" = 4
}

export type DefectCode = {
  code: string;
  shortGenName: string;
  category: string;
  subCategory: string;
};
